/**
 * Fixed UI copy of the forgotten-password dialog (Figma 60155:20067, 60155:20277, 60158:20811,
 * 60158:21486 and the mobile frames 60438:81985 – 60438:82686). It is not administration content and
 * the core dictionary has no matching strings, so it is kept in one block.
 */
export const RESET_COPY = {
  stepper: {
    label: 'Postup obnovenia hesla',
    steps: ['E-mail', 'Overenie', 'Nové heslo'],
    announce: (step: number, total: number, name: string) => `Krok ${step} z ${total}: ${name}`,
  },
  email: {
    title: 'Zabudli ste heslo?',
    text: 'Zadajte e-mail, ktorý ste použili pri registrácii. Pošleme vám odkaz na nastavenie nového hesla.',
    label: 'E-mail',
    placeholder: 'martakovacova@gmail.com',
    submit: 'Poslať odkaz na obnovenie',
    back: 'Späť na prihlásenie',
  },
  help: {
    question: 'Nemáte prístup k e-mailu?',
    call: 'Zavolajte nám na',
  },
  sent: {
    title: 'Skontrolujte si e-mail',
    text: (email: string | undefined) =>
      `Ak existuje účet s ${email ? `e-mailom ${email}` : 'touto e-mailovou adresou'}, poslali sme naň odkaz na nastavenie nového hesla. Odkaz je platný 60 minút.`,
    tip: 'Nevidíte e-mail? Pozrite sa do priečinka Spam alebo Promo akcie.',
    resend: 'Poslať e-mail znova',
    resent: 'Odkaz sme poslali znova.',
    countdown: (time: string) => `Znova môžete poslať o ${time}`,
    otherEmail: 'Zadať iný e-mail',
  },
  reset: {
    title: 'Nastavte si nové heslo',
    text: (email: string | undefined) =>
      `${email ? `Pre účet ${email}. ` : ''}Heslo musí byť iné ako to predchádzajúce.`,
    emailLabel: 'E-mail',
    password: 'Nové heslo',
    repeat: 'Zopakovať heslo',
    logoutOthers: 'Odhlásiť ma zo všetkých ostatných zariadení',
    submit: 'Uložiť nové heslo',
  },
  passwordRules: 'Heslo musí mať aspoň 8 znakov, veľké písmeno a číslo.',
  done: {
    title: 'Heslo bolo zmenené',
    text: 'Nové heslo je aktívne. Z bezpečnostných dôvodov sme vás odhlásili z ostatných zariadení a poslali potvrdenie na e-mail.',
    textKeptDevices: 'Nové heslo je aktívne. Na e-mail sme vám poslali potvrdenie.',
    signIn: 'Prihlásiť sa',
    continueShopping: 'Pokračovať v nákupe',
  },
} as const;
